import React from 'react';
import { Picker, Switch } from 'antd-mobile';
import CommonComponent from '../CommonComponent';
import { appMethod as app } from '@utils/app';
import { pageInstance } from '@utils/page';

import './FormPay.less';


export class FormPay extends CommonComponent {
  constructor(props) {
    super(props);
    this.options = this.props.options;

    this.state = {
      formInfo: {
        price: 0,
        form_data: {}
      },
      buttonInfo: '',
      remark: ''
    };
  }

  // 展示弹窗。小程序里面通过data里面的数据控制展示，这里是调用这个方法。参数和小程序一直
  show = (options) => {
    let {
      formInfo
    } = options;

    if(formInfo && formInfo.show === true){
      this.setData({
        formInfo: formInfo
      });
    }
  }

  discountChange = (val) => {
    var index = val;

    this.setData({
      'formInfo.selectDiscountInfo': this.data.formInfo.discountList[index] || '',
      'formInfo.selectDiscountIndex': index,
      'formInfo.calculData.selected_benefit': this.data.formInfo.discountList[index] || ''
    })
    this.calculateTotalPrice();
  }

  closeDialog = () => {
    this.setData({
      'formInfo.show' : false,
      'formInfo.useBalance': false
    });
    let thisPage = app.getAppCurrentPage();
    thisPage.setData({
      'formInfo.show': false
    })
  }

  inputRemark = (e) => {
    this.setData({
      remark : e.target.value
    })
  }

  confirmPay = () => {
    let _this = this;
    let inputPrice = +this.data.formInfo.price;
    let totalPayment = this.data.formInfo.totalPayment;
    let benefits = this.data.formInfo.selectDiscountInfo;
    if (isNaN(totalPayment) || totalPayment < 0) {
      alertTip('error payment amount');
      return;
    }

    if (this.data.requesting) {
      return;
    }
    this.setData({
      requesting: true
    });

    if (benefits.no_use_benefit == 1) {
      benefits = '';
    }

    app.sendRequest({
      url: '/index.php?r=AppShop/createTransferOrder',
      method: 'post',
      data: {
        price: inputPrice,
        check_price: totalPayment,
        message: this.data.remark,
        selected_benefit: benefits,
        is_balance: this.data.formInfo.useBalance == true ? 1 : 0,
        form_info: this.data.formInfo.submitData
      },
      success: function (res) {
        _this.setData({
          'formInfo.submitData.button_info.order_id': res.data
        })
        _this.payOrder(res.data);
      },
      fail: function(){
        _this.setData({
          requesting: false
        });
      }
    })
  }

  payOrder = (orderId) => {
    var _this = this;
    function paySuccess(){
      let newData = {
        'formInfo.show': false,
        remark: '',
        'formInfo.useBalance': false,
      };
      app.getAppCurrentPage().setData(newData);
      _this.setData({
        requesting: false
      });
      let formVesselCompindex = _this.data.buttonInfo.compindex;
      if (formVesselCompindex != -1) {
        pageInstance.callComponentMethod({
          componentIndex: formVesselCompindex,
          methodName: 'addFormDataSuccess',
          argvs: [_this.data.buttonInfo, {msg: ''}]
        });
      }
    } 

    function payFail() {
      app.sendRequest({
        url: '/index.php?r=AppShop/cancelOrder',
        data: {
          order_id: orderId
        },
        success: function (res) {
          
        },
        fail: function () {
          payFail();
        },
        complete: function () {
          _this.setData({
            requesting: false
          });
        }
      })
    }

    if (this.data.formInfo.totalPayment == 0) {
      app.sendRequest({
        url: '/index.php?r=AppShop/paygoods',
        data: {
          order_id: orderId,
          total_price: 0
        },
        success: function (res) {
          paySuccess();
        },
        fail: function () {
          payFail();
        }
      });
      return;
    }
    // app.sendRequest({
    //   url: '/index.php?r=AppShop/GetWxWebappPaymentCode',
    //   data: {
    //     order_id: orderId
    //   },
    //   success: function (res) {
    //     var param = res.data;

    //     param.orderId = orderId;
    //     param.goodsType = 5;
    //     param.success = paySuccess;
    //     param.fail = payFail;
    //     app.wxPay(param);
    //   },
    //   complete: function(){
    //     let newData = {
    //       'formInfo.show': false,
    //       remark: '',
    //       'formInfo.useBalance': false
    //     };
    //     _this.setData({
    //       requesting: false
    //     });
    //     app.getAppCurrentPage().setData(newData);
    //   }
    // })
    app.goPay({
      orderId: orderId
    });
    paySuccess();
  }

  calculateTotalPrice = (options) => {
    if(options){
      this.setData({
        buttonInfo: options
      })
    }
    let _this = this;
    let price = +this.data.formInfo.price;
    app.sendRequest({
      hideLoading: true,
      url: '/index.php?r=AppShop/calculationPrice',
      method: 'post',
      data: this.data.formInfo.calculData,
      success: function (res) {
        let data = res.data;
        let benefits = data.can_use_benefit.data;
        let selected_benefit;
        let selectDiscountIndex;

        if (benefits.length) {
          benefits.unshift({
            title: '不使用优惠',
            name: '无',
            no_use_benefit: 1
          });
        }
        
        selected_benefit = data.selected_benefit_info;
        for (let i = 0; i <= benefits.length - 1; i++) {
          let select_discount_type = selected_benefit.discount_type;
          if (select_discount_type === benefits[i].discount_type) {
            if (select_discount_type === 'coupon') {
              if (benefits[i].coupon_id == selected_benefit.coupon_id) {
                selectDiscountIndex = i;
                break;
              }
            } else {
              selectDiscountIndex = i;
              break;
            }
          }
        }

        _this.setData({
          'formInfo.totalPayment': data.price,
          'formInfo.discountList': benefits,
          'formInfo.selectDiscountInfo': selected_benefit,
          'formInfo.selectDiscountIndex': selectDiscountIndex || '',
          'formInfo.balance': data.balance,
          'formInfo.use_balance_count': data.use_balance,
          'formInfo.discount_cut_price': data.discount_cut_price 
        });
      }
    })
  }

  ifUseBalance = (val) => {
    this.setData({
      'formInfo.useBalance': val,
      'formInfo.calculData.is_balance': val == true ? 1 : 0
    })
    this.calculateTotalPrice();
  }
  
  
  render() {
    const {
      formInfo,
      remark
    } = this.state;
    // WEBAPP  TODO
    let discountListPickerData = (formInfo.discountList && formInfo.discountList.map((item, index) => ({
      label: item.title,
      value: index
    }))) || [];
    if(!formInfo.show){
      return null;
    }
    return (
      <div className="common-component form-pay form-pay-dialog">
        <div className="form-title">付款给 {formInfo.name} <img className="cheques-img" src={formInfo.logo} /></div>
        <div className="form-content">
          <div style={{color: '#333'}}><span>¥</span><span className="form-price">{formInfo.price}</span></div>
          {formInfo.isDiscount && (
            <React.Fragment>
              <Picker data={discountListPickerData} cols={1} value={formInfo.selectDiscountIndex} onChange={this.discountChange}>
              <div className="picker"><span className="left-label">使用优惠</span><span style={{color: '#ff7100'}}>{formInfo.selectDiscountInfo && formInfo.selectDiscountInfo.title || '无'}</span><span className="ico-moon icon-downarrow" style={{float: 'right', lineHeight: '1em'}}></span></div>
              </Picker>
              <div><span className="left-label" style={{height: '.64rem',lineHeight: '.64rem'}}>使用储值抵扣</span>{formInfo.useBalance && <span style={{color: '#ff7100'}}>抵{formInfo.use_balance_count}元</span>}<Switch className="pull-right" checked={ formInfo.useBalance } onChange={this.ifUseBalance} platform="ios" /></div>
            </React.Fragment>
          )}
          <div className="marign-top"><span className="left-label">备注</span><textarea className="remarks" onChange={this.inputRemark} value={remark}></textarea></div>
          <div className="marign-top actual-pay"><span className="left-label">实际付款</span><span style={{color: '#ff7100', float: 'right'}} >¥<span className="actual-price">{formInfo.totalPayment}</span></span></div>
          <button className="pay-btn marign-top" onClick={this.confirmPay}>确认支付</button>
          <div className="form-pay-close ico-moon icon-closes" onClick={this.closeDialog}></div>
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/common/form-pay/FormPay.jsx